import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { ProjectTaskRouter } from './project-task.router';
import { reducers } from './state/project-task.selectors';

@NgModule({
  imports: [
    ProjectTaskRouter,
    StoreModule.forFeature('projectTask', reducers),
  ],
  declarations: []
})
export class ProjectTaskExtScreenModule { }